module.exports = __webpack_public_path__ + "img/T6-A-xh_02.565f2e67.png";